module.exports = __webpack_public_path__ + "images/emoji/tram.cf839617b5e64b4a2ef1.png";